import { combineReducers } from 'redux'
import view from './view'
import elements from './elements'
import checklistItems from './checklistItems'
import documentListItems from './documentListItems'
import subCards from './subCards'
import observers from './observers'
import visitors from './visitors'
import activities from './activities'
import dates from './dates'
import myBoard from './myBoard'
import incomingMails from './incomingMails'

export default combineReducers({
  view,
  elements,
  checklistItems,
  documentListItems,
  subCards,
  observers,
  visitors,
  activities,
  dates,
  myBoard,
  incomingMails,
})
